import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { getOurPupsBlocks } from '../data/marketing';

export default function WhyMarysPlushPupsSection({ brand, whatsappUrl, onViewCatalogue }) {
  const blocks = useMemo(() => getOurPupsBlocks(brand), [brand]);

  return (
    <section className="our-pups" id="why-marys">
      <div className="our-pups-inner">
        <motion.div
          className="why-plush-head"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
        >
          <div className="why-plush-kicker">Why Mary’s Plush Pups</div>
          <h2 className="why-plush-title">OUR PUPS MAKE THE PERFECT COMPANION</h2>
          <p className="why-plush-sub">
            Loving, plush pups raised with care — here’s what makes our process smooth, supportive, and family-first.
          </p>
        </motion.div>

        {blocks.map((block, idx) => (
          <motion.div
            key={block.title}
            className={`our-pups-row ${idx % 2 === 1 ? 'is-reversed' : ''}`}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="our-pups-copy">
              <div className="our-pups-eyebrow" aria-hidden="true">
                {block.eyebrow}
              </div>
              <h3 className="our-pups-title">{block.title}</h3>
              <p className="our-pups-body">{block.body}</p>
              <ul className="our-pups-points">
                {block.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
              <div className="our-pups-actions">
                <button
                  className="our-pups-cta"
                  type="button"
                  onClick={
                    block.cta.toLowerCase().includes('whatsapp')
                      ? () => window.open(whatsappUrl, '_blank', 'noreferrer')
                      : onViewCatalogue
                  }
                >
                  {block.cta}
                </button>
              </div>
            </div>
            <div className="our-pups-media">
              <div className="video-frame">
                <video src={block.video} autoPlay muted playsInline loop preload="auto" controls={false} />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

